import React from 'react';
import ModalV4 from '../../../../app/ui/modal/v4/v4';
import VScroll from '../../../gd-components/scrolling/custom-v-scroll/v-scroll';
import ModalV4Header from "../../../../app/ui/modal/v4/header/v4-header";
import CustomViewAccessForm from "./form-edit";
import CustomViewAccessSharedWith from "./shared-with";

module.exports = class ModalCustomViewAccessSettings extends ModalV4 {

    render() {

        let Component;
        if (this.props.params.view.userId === gd.user.id) {
            Component = <CustomViewAccessForm view={this.props.params.view} />;
        } else {
            Component = <CustomViewAccessSharedWith view={this.props.params.view} />;
        }

        return (
            <div className="v4-container placement-middle" onClick={this.stopPropagation}>
                <ModalV4Header height={60} title="Access" onClose={this.closeModal} />
                <VScroll>
                    {Component}
                </VScroll>
            </div>
        )
    }
};